import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
// namespace SlotGames2 {
	export class StickyChilli2 extends SlotGameType1_2
	{
   
		//protected override freegameBonusFactory: FreegameBonusFactory2 = new StickyChillFreegame2BonusFactory();
		protected override seconScreenHelpFactory:ISlideFactoryGeneric = new FactoryDoubleSlide();
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", "." + this.resid.ScopedResourceName(["font"])));
		// }
	}
// }